<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="respondida" :resaltar="resaltar">
    <div class="d-flex flex-wrap sheet-opciones-grupo" role="group">
      <button v-for="op in opciones" :key="op.valor" type="button" class="btn btn-sheet-opcion mb-1"
              :class="[value === op.valor ? claseActiva : 'btn-outline-secondary']"
              :disabled="soloLectura" @click.prevent="marcar(op.valor)">{{ op.etiqueta }}</button>
    </div>
    <slot name="dependiente"></slot>
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/**
 * Selección única. Las etiquetas llegan literales desde la ficha; este componente
 * no las interpreta ni las reescribe.
 */
export default {
  name: "QOpcionUnica",
  components: { QFila },
  props: {
    value: { default: null },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    opciones: { type: Array, required: true },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
    incidencia: { type: Boolean, default: false },
  },
  computed: {
    respondida() {
      return this.value !== null && this.value !== undefined && this.value !== "";
    },
    claseActiva() {
      return this.incidencia ? "btn-danger" : "btn-primary";
    },
  },
  methods: {
    marcar(v) {
      if (this.soloLectura) return;
      const nuevo = this.value === v ? null : v;
      this.$emit("input", nuevo);
      this.$emit("cambio", nuevo);
    },
  },
};
</script>
